import React, { useState } from 'react'
import { createZustandContext, createUseClientState, Replacer } from 'state/utilities'
import { createStore } from 'zustand'
import { getInitialClientState } from './helpers'
import { pick } from 'utilities/object'

const UserClientStateContext = createZustandContext('User')

const UserClientStateProvider = ({ children, ...props }) => {
    const [store] = useState(createStore(set => ({
        ...getInitialClientState(props),

        reset: () => set(getInitialClientState(props)),
        refresh: () => set(pick(getInitialClientState(props), 'signal'))
    })))

    return (
        <UserClientStateContext.Provider value={store}>
            {children}
            <Replacer
                useClientState={useUserClientState}
                props={props}
                on={['id']} />
        </UserClientStateContext.Provider>
    )
}

export const useUserClientState = createUseClientState(UserClientStateContext)

export * from './mutators'
export * from './helpers'
export default UserClientStateProvider